import { CFBaseLogoTokens } from '../Logo.styles';
export const getLogoColor = (color) => {
    if (Object.keys(CFBaseLogoTokens.COLORS).includes(color)) {
        return CFBaseLogoTokens.COLORS[color];
    }
    return color;
};
